import { atomWithReset } from 'jotai/utils'

import { type CoreMember } from './hooks/useMainQuery'

type DialogInfo =
  | {
      coreMember: CoreMember
      dialogType: 'delete'
    }
  | {
      dialogType: 'add'
    }

export const dialogInfoAtom = atomWithReset<DialogInfo | undefined>(undefined)
